import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class InvalidIdError extends CodedError {
  static get errorName() {
    return errorCodes.invalidIdError.code;
  }

  constructor(message: string = errorCodes.invalidIdError.message) {
    super(message);
    this.code = errorCodes.invalidIdError.code;
    this.message = `${message} ${errorCodes.invalidIdError.code}`;
    this.name = errorCodes.invalidIdError.name;
  }
}
